module.exports = __webpack_public_path__ + "img/service2-06.1ef2a8a7.png";